import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { TiTick } from "react-icons/ti";
const WhyChooseKarline = () => {
  return (
    <>
      <div style={{ background: "#000", padding: "30px 0 15px", margin: "0" }}>
        <Container>
          <Row>
            <Col lg={12}>
              <div
                style={{
                  color: "#fff",
                  textAlign: "center",
                  fontWeight: "500",
                  marginBottom: "30px",
                  marginTop: "0",
                  fontSize: "2rem",
                }}
              >
             <span style={{color:"Red",    fontSize: "25px",}}>WHY CHOOSE</span>   Execlane
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div style={{ padding: "40px 0", background: "#f7f7f7" }}>
        <Container>
          <Row>
            <Col sm={12} xs={6} md={6}>
              <div
                style={{
                  fontSize: "18px",
                  margin: "20px",
                  marginLeft: "0",
                  fontFamily: "Lato,sans-serif",
                }}
              >
                <TiTick
                  color="#000"
                  size="25px"
                  style={{ marginRight: "20px" }}
                />
                <strong
                  style={{
                    color: "rgb(42, 157, 244)",
                    fontSize: "18px",
                    fontFamily: "'Poppins', sans-serif",
                    color: "#444",
                    textDecoration: "none",
                    fontWeight: "700",
                  }}
                >
                  Competitive rate
                </strong>{" "}
                All-inclusive pricing
              </div>
              <div
                style={{
                  fontSize: "18px",
                  margin: "20px",
                  marginLeft: "0",
                  fontFamily: "Lato,sans-serif",
                }}
              >
                <TiTick
                  color="#000"
                  size="25px"
                  style={{ marginRight: "20px" }}
                />
                <strong
                  style={{
                    color: "#000",
                    fontSize: "18px",
                    fontFamily: "'Poppins', sans-serif",
                    color: "#444",
                    textDecoration: "none",
                    fontWeight: "700",
                  }}
                >
                  Seamless travel
                </strong>{" "}
                -travel
              </div>
              <div
                style={{
                  fontSize: "18px",
                  margin: "20px",
                  marginLeft: "0",
                  fontFamily: "Lato,sans-serif",
                }}
              >
                <TiTick
                  color="#000"
                  size="25px"
                  style={{ marginRight: "20px" }}
                />
                <strong
                  style={{
                    color: "#000",
                    fontSize: "18px",
                    fontFamily: "'Poppins', sans-serif",
                    color: "#444",
                    textDecoration: "none",
                    fontWeight: "700",
                  }}
                >
                  Experienced 
                </strong>{" "}
                trained chauffeur
                {/* and stable uptime */}
              </div>
            </Col>
            <Col sm={12} xs={6} md={6}>
              {" "}
              <div
                style={{
                  fontSize: "18px",
                  margin: "20px",
                  marginLeft: "0",
                  fontFamily: "Lato,sans-serif",
                }}
              >
                <TiTick
                  color="#000"
                  size="25px"
                  style={{ marginRight: "20px" }}
                />
                <strong
                  style={{
                    color: "#000",
                    fontSize: "18px",
                    fontFamily: "'Poppins', sans-serif",
                    color: "#444",
                    textDecoration: "none",
                    fontWeight: "700",
                  }}
                >
                  Executive fleet
                </strong>{" "}
                Comfort ride
              </div>
              <div
                style={{
                  fontSize: "18px",
                  margin: "20px",
                  marginLeft: "0",
                  fontFamily: "Lato,sans-serif",
                }}
              >
                <TiTick
                  color="#000"
                  size="25px"
                  style={{ marginRight: "20px" }}
                />
                <strong
                  style={{
                    color: "#000",
                    fontSize: "18px",
                    fontFamily: "'Poppins', sans-serif",
                    color: "#444",
                    textDecoration: "none",
                    fontWeight: "700",
                  }}
                >
                  Travel 
                </strong>{" "}
                on your terms
              </div>
              <div
                style={{
                  fontSize: "18px",
                  margin: "20px",
                  marginLeft: "0",
                  fontFamily: "Lato,sans-serif",
                }}
              >
                <TiTick
                  color="#000"
                  size="25px"
                  style={{ marginRight: "20px" }}
                />
                <strong
                  style={{
                    color: "#000",
                    fontSize: "18px",
                    fontFamily: "'Poppins', sans-serif",
                    color: "#444",
                    textDecoration: "none",
                    fontWeight: "700",
                  }}
                >
                  Flexible
                </strong>{" "}
                cancelation{" "}
              </div>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              {" "}
              <div
                style={{
                  fontSize: "25px",
                  textAlign: "center",
                  margin: "10px",
                  padding: "20px",
                  border: "2px solid #000",
                  borderRadius: "5px",
                  display: "block",
                  fontFamily: "Poppins, sans-serif",
                }}
              >
                {" "}
                <strong style={{ color: "#000", fontWeight: "700" }}>
                  Our Drivers are licensed and trained to give {` `}
                </strong>
                you the best service possible.
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default WhyChooseKarline;
